import { render } from "./RelayLoginData.vue?vue&type=template&id=a5e4f7b0"
import script from "./RelayLoginData.vue?vue&type=script&lang=js"
export * from "./RelayLoginData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__